<div>
  <div class="header-navigation-back">
    <mat-icon (click)="goBack()" data-test="back-arrow-icon">arrow_back</mat-icon>
    <span class="title" data-test="edit-button">Edit Profile</span>
  </div>
  <div class="content">
    @if (form) {
      <form [formGroup]="form">
        @if (loading) {
          <app-loading-gif></app-loading-gif>
        }
        <div class="cards-container" [hidden]="loading">
          
          <!-- Profile Picture Card -->
          <div class="card-wrapper" style="text-align: center;">
            <mat-card class="profile-card">
              <mat-card-content class="profile-container">
                <img [src]="profilePicture" class="profile-image" />
                <mat-icon
                  svgIcon="edit-icon"
                  class="edit-icon"
                  (click)="onNavigateToProfilePicture()"
                  data-test="add-profile-pic"
                  data-testid="profile-pic-btn"
                ></mat-icon>
              </mat-card-content>
            </mat-card>
          </div>

          <!-- Personal Information Card -->
          <div class="card-wrapper">
            <mat-card class="info-card personal-info-card">
              <mat-card-content class="card-content" data-test="driver-info">
                <div class="section-header">
                  <mat-icon class="section-icon">person</mat-icon>
                  <span class="section-title" data-testid="personal-info-title">Personal Info</span>
                </div>
              <div class="form-row">
                <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>First Name</mat-label>
                  <input
                    matInput
                    #firstName
                    formControlName="firstName"
                    data-test="first-name-form-field"
                    data-testid="first-name-form-field"
                    required
                    />
                  @if (form.get('firstName')?.touched && form.get('firstName')?.invalid) {
                    <mat-error data-testid="firstName-error-message">
                      {{ getFirstNameErrorMessage() }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-row">
                <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Last Name</mat-label>
                  <input
                    matInput
                    #lastName
                    formControlName="lastName"
                    data-test="last-name-form-field"
                    data-testid="last-name-form-field"
                    required
                    />
                  @if (form.get('lastName')?.touched && form.get('lastName')?.invalid) {
                    <mat-error data-testid="lastName-error-message">
                      {{ getLastNameErrorMessage() }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-row">
                <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Date Of Birth</mat-label>
                  <input
                    matInput
                    [matDatepicker]="dateOfBirth"
                    formControlName="dateOfBirth"
                    data-testid="date-picker-btn"
                    [max]="maxDate"
                    required
                    (click)="onDatePickerClick(dateOfBirth)"
                    (focus)="onDatePickerClick(dateOfBirth)"
                    />
                  <mat-datepicker-toggle matSuffix [for]="dateOfBirth" data-test="dob-form-field"></mat-datepicker-toggle>
                  <mat-datepicker touchUi="true" #dateOfBirth></mat-datepicker>
                  @if (form.get('dateOfBirth')?.touched && form.get('dateOfBirth')?.invalid) {
                    <mat-error data-testid="dob-warning">
                      {{ getDateOfBirthErrorMessage() }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-row">
                <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Gender</mat-label>
                  <mat-select formControlName="gender" data-test="gender-form-field" required>
                    <mat-option value="male" data-test="gender-value">Male</mat-option>
                    <mat-option value="female" data-test="gender-value">Female</mat-option>
                  </mat-select>
                  @if (form.get('gender')?.touched && form.get('gender')?.invalid) {
                    <mat-error data-testid="gender-error-message">Select a gender</mat-error>
                  }
                </mat-form-field>
              </div>
              </mat-card-content>
            </mat-card>
          </div>
          
          <!-- Contact Information Card -->
          <div class="card-wrapper">
            <mat-card class="info-card contact-info-card">
              <mat-card-content class="card-content" data-test="driver-info">
                <div class="section-header">
                  <mat-icon class="section-icon">contact_mail</mat-icon>
                  <span class="section-title">Contact</span>
                </div>
              <!-- Google Address Lookup — always use autocomplete -->
              <!-- Manual address toggle commented out — Google autocomplete covers 99%+ of addresses
              <div class="turnoff-text" (click)="onGoogleAddressLookupToggle($event)">
                {{ isGoogleAddressLookupEnabled ? 'Enter Address Manually' : 'Use Address Autocomplete' }}
              </div>
              -->
              <div class="form-row">
                <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Address</mat-label>
                  <input
                    matInput
                    formControlName="address"
                    #addressText
                    required
                    data-test="address-field"
                    data-testid="address-field"
                    autocomplete="on"
                    />
                  @if (form.get('address')?.touched && form.get('address')?.invalid) {
                    <mat-error>
                      {{ getAddressErrorMessage() }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <!-- Manual address fields removed — Google autocomplete covers 99%+ of addresses.
                   See git history to restore if needed. -->
              <div class="form-row">
                <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Work Status</mat-label>
                  <mat-select formControlName="workStatus" data-test="workStatus-form-field" data-testid="workStatus-form-field" required>
                    @for (status of workStatues; track status) {
                      <mat-option [value]="status.name" data-test="workStatus-value" [attr.data-testid]="'option-' + status?.name?.toLowerCase()">{{
                        status.displayName
                      }}</mat-option>
                    }
                  </mat-select>
                  @if (form.get('workStatus')?.touched && form.get('workStatus')?.invalid) {
                    <mat-error data-testid="workStatus-error-message">Select a work status</mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-row">
                <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Phone</mat-label>
                  <input
                    matInput
                    autocomplete="off"
                    appPhoneMask
                    formControlName="phone"
                    maxlength="12"
                    data-test="phone-field"
                    data-testid="phone-field"
                    required
                    />
                  @if (form.get('phone')?.touched && form.get('phone')?.invalid) {
                    <mat-error data-testid="phone-error-message">
                      {{ form.get('phone')?.errors?.required ? 'Enter your phone number' : 'Enter phone as ###-###-####' }}
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div class="form-row disabled">
                <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
                  <mat-label>Email</mat-label>
                  <input matInput formControlName="email" readonly />
                </mat-form-field>
              </div>
              </mat-card-content>
            </mat-card>
          </div>
          
          <!-- Emergency Contacts Card -->
          <div class="card-wrapper">
            <mat-card class="info-card emergency-contact-card">
              <mat-card-content class="card-content">
                <div class="section-header">
                  <mat-icon class="section-icon">contact_emergency</mat-icon>
                  <span class="section-title" data-testid="emergencyContact-title">Emergency Contact(s)</span>
                  @if (form && emergencyContacts && emergencyContacts.length < 2) {
                    <div class="add-btn" (click)="addEmergencyContact()">
                      <mat-icon class="add-emergency" svgIcon="add-plus-icon"></mat-icon>
                    </div>
                  }
                </div>
              <div formArrayName="emergencyContacts">
                @for (contact of emergencyContacts?.controls; track contact; let i = $index) {
                  <div class="emergency-contact-section">
                    <div class="emergency-contact-title">Emergency Contact {{ i + 1 }}</div>
                    <div class="emergency-divider"><mat-divider></mat-divider></div>
                    <div [formGroupName]="i">
                      <div class="form-row">
                        <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
                          <mat-label>Name</mat-label>
                          <input
                            matInput
                            formControlName="emergencyContactName"
                            data-test="emergency-name-form-field"
                            [attr.data-testid]="'emergency-name-' + i + '-form-field'"
                            required
                            />
                          @if (getEmergencyContactError(i, 'emergencyContactName')) {
                            <mat-error data-testid="emergency-contact-error">
                              {{ getEmergencyContactError(i, 'emergencyContactName') }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="form-row">
                        <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
                          <mat-label>Relation</mat-label>
                          <input
                            matInput
                            formControlName="emergencyContactRelation"
                            data-test="relation-form-field"
                            [attr.data-testid]="'relation-' + i + '-form-field'"
                            required
                            />
                          @if (getEmergencyContactError(i, 'emergencyContactRelation')) {
                            <mat-error data-testid="relation-error-message">
                              {{ getEmergencyContactError(i, 'emergencyContactRelation') }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="form-row">
                        <mat-form-field class="full-width" appearance="outline" subscriptSizing="dynamic">
                          <mat-label>Phone</mat-label>
                          <input
                            matInput
                            appPhoneMask
                            formControlName="emergencyContactPhone"
                            maxlength="12"
                            data-test="phone-field"
                            [attr.data-testid]="'emergency-phone-' + i + '-form-field'"
                            required
                            />
                          @if (getEmergencyContactError(i, 'emergencyContactPhone')) {
                            <mat-error data-testid="emergency-phone-error">
                              {{ getEmergencyContactError(i, 'emergencyContactPhone') }}
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                }
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          
        </div>
      </form>
    }
    <div class="fixed-footer">
      <button
        mat-stroked-button
        class="btn-cancel modern-btn"
        (click)="goBack()"
        data-test="cancel-button"
        data-testid="cancel-button"
        >
        <mat-icon>close</mat-icon>
        Cancel
      </button>
      <button
        mat-flat-button
        class="btn-save modern-btn"
        (click)="onSubmit()"
        [disabled]="(!form.dirty || !form.valid) && !loading"
        data-test="save-button"
        data-testid="save-button"
        >
        @if (!loading) {
          <mat-icon>check</mat-icon>
        }
        @if (loading) {
          <mat-spinner diameter="18"></mat-spinner>
        }
        <span [class.loading-text]="loading">{{ loading ? 'Saving...' : 'Save' }}</span>
      </button>
    </div>
  </div>
</div>
